/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';

export const activityDtoSchema = z.object({
  id: z.coerce.number().int().optional(),
  employeeValue: z.coerce.number().int(),
  employeeLabel: z.coerce.string(),
  clientLabel: z.coerce.string(),
  clientValue: z.coerce.number().int(),
  projectValue: z.coerce.number().int().nullable(),
  projectLabel: z.coerce.string().nullable(),
  macroProjectValue: z.coerce.number().int().nullable(),
  macroProjectLabel: z.coerce.string().nullable(),
  costCenterLabel: z.coerce.string().nullable(),
  costCenterValue: z.coerce.number().int().nullable(),
  description: z.coerce.string().nullable().nullish(),
  date: z.string().date(),
  year: z.coerce.number().int(),
  month: z.coerce.number().int(),
  fromTime: z.string().time(),
  toTime: z.string().time(),
  effectiveHours: z.coerce.number(),
  km: z.coerce.number().nullable().nullish(),
  extraCosts: z.coerce.number().nullable().nullish(),
  costsDescription: z.coerce.string().nullable().nullish(),
});
